<template>
  <!-- cambia classe in base allo stato (piccolo/grande) -->
  <div
    v-show="isReady"
    :class="{'barra-menu-piccola' : !vociMenu && !hoverMenu, 'barra-menu-grande' : vociMenu || hoverMenu}"
    @mouseenter="apriMenuPiccolo"
    @mouseleave="chiudiMenuGrande">
    <div :class="vociMenu || hoverMenu ? 'button-unlock-container' : 'button-lock-container'">
      <!-- bottone per bloccare o sbloccare il menu -->
      <button class="button-lock" @click="toggleLock" :title="vociMenu || hoverMenu ? 'Unlock' : 'Lock'">
        <img class="button-lock-img" :src="vociMenu || hoverMenu ? '/img-appalto/menu/unlock.svg' : '/img-appalto/menu/lock.svg'">
      </button>
    </div>

    <!-- transizione 'fade' -->
    <transition name="fade">
      <PanelMenu
        ref="panelMenuRef"
        v-if="menuVisibile"
        :model="processedItems"
        v-model:expandedKeys="expandedKeys"
        :class="{ 'menu-unlock': !vociMenu }">

        <template #item="{ item, parent }">
          <a v-ripple
             class="flex menu-link items-center cursor-pointer group"
             :href="item.to"
             @click="handleItemClick($event, item, parent)"
             :class="{ 'parent-espanso': isParentExpanded(item) }">

            <!-- icona sempre renderizzata -->
            <img
              :src="isItemActive(item) ? getHoverIcon(item.icon) : item.icon"
              alt="Icona del menu"
              class="menu-icon"
              :class="{ 'active': isItemActive(item) }"
            />

            <!-- qui mostri/nascondi SOLO testo + freccia -->
            <div class="container-menu-link">
              <span v-show="vociMenu || hoverMenu" class="ml-2 prima-voce"
                    :class="{ 'prima-voce-active': isItemActive(item) }">
                {{ item.label }}
              </span>

              <span v-show="(vociMenu || hoverMenu) && item.items" class="menu-arrow">
                <img
                  src="/img-appalto/menu/angle_down.svg"
                  alt=""
                  class="arrow-icon"
                  :class="{ 'arrow-expanded': isExpanded(item) }"
                >
              </span>
            </div>
          </a>
        </template>


      </PanelMenu>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import PanelMenu from 'primevue/panelmenu';

export default {
  name: "MenuSx",
  components: {
    PanelMenu,
  },
  data() {
    return {
      items: [],
      selectedItemId: null,
      menuVisibile: true,
      vociMenu: false, //stato piccolo/grande
      hoverMenu: false, // nuovo: menu temporaneamente aperto
      bloccato: false,
      currentPath: '',
      activeItem: null,
      activeParent: null,
      expandedKeys: {}, // traccia gli item espansi (usato da PanelMenu)
      isReady: false,
    };
  },
  computed: {
    processedItems() {
      console.log('vociMenu', this.items);
      return this.items.map((item) => {
        const itemKey = item.key || item.label;
        const newItem = {
          ...item,
          key: itemKey,
          class: this.vociMenu || this.hoverMenu ? 'primo_livello_submenu' : 'primo_livello'
        };

        if (item.items && item.items.length > 0) {
          newItem.items = (this.vociMenu || this.hoverMenu)
            ? item.items.map((subItem) => ({
                ...subItem,
                key: subItem.key || subItem.label,
                class: 'secondo_livello'
              }))
            : [];
        }

        return newItem;
      });
    }
  },
  created() {
    const menuSalvato = localStorage.getItem('menuBloccato');
    if (menuSalvato !== null) {
      this.bloccato = JSON.parse(menuSalvato);
      this.vociMenu = this.bloccato;

      // Sincronizza le classi del body con lo stato salvato
      this.$nextTick(() => {
        const body = document.body;
        if (this.bloccato) {
          body.classList.add('layout-pinned');
          body.classList.remove('layout-collapsed');
        } else {
          body.classList.remove('layout-pinned');
          body.classList.add('layout-collapsed');
        }
      });
    }

    this.currentPath = window.location.pathname;

    axios.get('/menu_sx')
      .then(response => {
        this.items = response.data;

        // Trova l'item che corrisponde alla rotta corrente
        const found = this.findItemByTo(this.items, this.currentPath);
        if (found) {
          const parent = this.getParentByItem(found.item, this.items);
          this.activeItem = found.item;
          this.activeParent = parent;

          // Espandi automaticamente il parent se l'item attivo è un figlio
          if (parent) {
            const parentKey = parent.key || parent.label;
            this.expandedKeys = { ...this.expandedKeys, [parentKey]: true };
          }
        }
      })
      .finally(() => {
        this.isReady = true;
      });

  },


  methods: {
    isItemActive(item) {
      if (!this.activeItem) return false;

      // Evidenzia l'item che corrisponde esattamente alla rotta corrente
      if (this.activeItem.to === item.to && this.activeItem.label === item.label) {
        return true;
      }

      // Evidenzia anche il parent se contiene l'item attivo
      if (this.activeParent && this.activeParent.label === item.label) {
        return true;
      }

      return false;
    },
    isActive(item) {
      if (!this.$refs.panelMenuRef) return false;
      const el = this.$refs.panelMenuRef.$el.querySelector(`[data-label="${item.label}"]`);

      return el ? el.getAttribute('data-p-active') === 'true' : false;
    },
    getHoverIcon(iconPath) {
      const lastDotIndex = iconPath.lastIndexOf('.');
      if (lastDotIndex === -1) return iconPath;
      const basePath = iconPath.substring(0, lastDotIndex);
      const extension = iconPath.substring(lastDotIndex);
      return basePath + '_hover' + extension;
    },
    goToUrl(item) {
      const url = typeof item === 'string' ? item : item.to;
      if (url) {
        window.location.href = url;
      }
    },
    handleItemClick(event, item, parent) {
      // Se l'item ha sottomenu, lascia che PanelMenu gestisca l'espansione
      if (item.items) {
        // Non fare preventDefault - PanelMenu gestirà il toggle
        return;
      }

      // Per gli item senza sottomenu, gestisci la navigazione
      event.preventDefault();
      this.setActiveItem(item, parent);
    },
    setActiveItem(item, parent = null) {
      if (this.activeItem && this.activeItem.label === item.label) {
        this.activeItem = null;
      } else {
        this.activeItem = item;
        if (!parent) {
          parent = this.getParentByItem(item, this.items);
        }
        this.activeParent = parent;
      }

      if (item.to) {
        this.goToUrl(item, parent);
      }
    },
    toggleLock() {
      this.bloccato = !this.bloccato;
      this.vociMenu = this.bloccato;
      localStorage.setItem('menuBloccato', JSON.stringify(this.bloccato));

      // Gestisci le classi del body
      const body = document.body;
      const menuOpener = document.getElementById('menu-opener');

      if (this.bloccato) {
        body.classList.add('layout-pinned');
        body.classList.remove('layout-collapsed');
        // Rimuovi menu-chiuso-container quando il menu è bloccato aperto
        if (menuOpener) {
          menuOpener.classList.remove('menu-chiuso-container');
        }
      } else {
        body.classList.remove('layout-pinned');
        body.classList.add('layout-collapsed');
        // Aggiungi menu-chiuso-container quando il menu è sbloccato
        if (menuOpener) {
          menuOpener.classList.add('menu-chiuso-container');
        }
      }

      // Forza chiusura del menu temporaneo se era aperto in hover
      if (!this.bloccato) {
        this.hoverMenu = false;
      }

      // Eventuale notifica a componenti esterni
      window.dispatchEvent(new CustomEvent('menu-toggle', { detail: this.vociMenu }));
    },

    apriMenuPiccolo() {
      if (!this.vociMenu && !this.bloccato) {
        this.hoverMenu = true; // menu temporaneamente grande
      }
    },

    chiudiMenuGrande() {
      if (!this.bloccato) {
        this.hoverMenu = false; // torna piccolo
      }
      const spaceMenu = document.querySelector('.space-menu');
      if (spaceMenu) spaceMenu.style.display = 'none';
    },
    findItemByTo(items, currentPath) {
      // Normalizza il path: estrae solo il pathname da URL complete
      const normalizePath = (path) => {
        if (!path) return '';
        let normalized = path.trim().replace(/^"|"$/g, '');

        // Se è una URL completa, estrai solo il pathname
        try {
          const url = new URL(normalized);
          normalized = url.pathname;
        } catch (e) {
          // Non è una URL completa, usa il path così com'è
        }

        // Rimuove query string e slash finale
        return normalized.split('?')[0].replace(/\/$/, '');
      };

      const normalizedCurrentPath = normalizePath(currentPath);

      for (let item of items) {
        if (item.to) {
          const normalizedItemTo = normalizePath(item.to);
          if (normalizedItemTo === normalizedCurrentPath) {
            return {item};
          }
        }

        if (item.items) {
          const found = this.findItemByTo(item.items, currentPath);
          if (found) return found;
        }
      }
      return null;
    },
    getParentByItem(item, items) {
      // Funzione helper per normalizzare i path
      const normalizePath = (path) => {
        if (!path) return '';
        let normalized = path.trim().replace(/^"|"$/g, '');
        try {
          const url = new URL(normalized);
          normalized = url.pathname;
        } catch (e) {
          // Non è una URL completa
        }
        return normalized.split('?')[0].replace(/\/$/, '');
      };

      const itemTo = normalizePath(item.to);

      for (let parent of items) {
        if (parent.items) {
          const found = parent.items.find(subItem => {
            const subItemTo = normalizePath(subItem.to);
            return subItem.label === item.label && subItemTo === itemTo;
          });
          if (found) return parent;
        }
      }
      return null;
    },
    getParentIndexByItem(item, items) {
      // Restituisce l'indice del parent nell'array items
      const normalizePath = (path) => {
        if (!path) return '';
        let normalized = path.trim().replace(/^"|"$/g, '');
        try {
          const url = new URL(normalized);
          normalized = url.pathname;
        } catch (e) {}
        return normalized.split('?')[0].replace(/\/$/, '');
      };

      const itemTo = normalizePath(item.to);

      for (let i = 0; i < items.length; i++) {
        const parent = items[i];
        if (parent.items) {
          const found = parent.items.find(subItem => {
            const subItemTo = normalizePath(subItem.to);
            return subItem.label === item.label && subItemTo === itemTo;
          });
          if (found) return i;
        }
      }
      return null;
    },
    isParentExpanded(item) {
      // ritorna true se questo item è già espanso
      return this.activeParent && this.activeParent.label === item.label;
    },
    isExpanded(item) {
      const key = item.key || item.label;
      return !!this.expandedKeys[key];
    },
    toggleExpand(item) {
      const key = item.key || item.label;
      if (this.expandedKeys[key]) {
        const newKeys = { ...this.expandedKeys };
        delete newKeys[key];
        this.expandedKeys = newKeys;
      } else {
        this.expandedKeys = { ...this.expandedKeys, [key]: true };
      }
    }
  }
}

</script>

<style scoped>
</style>